const defaultPostParam = {
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'include', // include, same-origin, *omit
    headers: {
        'content-type': 'application/json;charset=UTF-8'
    },
    // method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, cors, *same-origin
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer', // *client, no-referrer
};
const defaultGetParam = {
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'include', // include, same-origin, *omit
    headers: {
        'Content-type': 'application/json;charset=UTF-8'
    },
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, cors, *same-origin
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer', // *client, no-referrer
};
const defaultFileParam = {
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'include', // include, same-origin, *omit=
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, cors, *same-origin
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer', // *client, no-referrer
};

async function getJson(url, param) {
    url = getAsUriParameters(url, param);
    let p = Object.assign(defaultGetParam, param);
    let response = await fetch(url, p);
    return await handleResponseJson(response);
}

async function postJson(url, body, param) {
    let p = Object.assign(defaultPostParam, param);
    p.method = "POST";
    p.body = JSON.stringify(body);
    let response = await fetch(url, p);
    return await handleResponseJson(response);
}

async function postFile(url, formData, param) {
    let p = Object.assign(defaultFileParam, param);
    p.method = "POST";
    p.body = formData;
    let response = await fetch(url, p);
    return await handleResponseJson(response);
}

async function putJson(url, body, param) {
    let p = Object.assign(defaultPostParam, param);
    p.method = "PUT";
    p.body = JSON.stringify(body);
    let response = await fetch(url, p);
    return await handleResponseJson(response);
}

async function delJson(url, body, param) {
    let p = Object.assign(defaultPostParam, param);
    p.method = "DELETE";
    p.body = JSON.stringify(body);
    let response = await fetch(url, p);
    return await handleResponseJson(response);
}

async function handleResponseJson(response) {
    if (response.ok) {
        let data = await response.json();
        if (data.success) {
            return data.data;
        } else {
            let f = false;
            let handler;
            for (let i=0;i<jsonErrorHandlers.length;i++) {
                if (jsonErrorHandlers[i](data)) {
                    f = true;
                    break;
                }
            }
            if (!f) {
                alert(data.errormsg ? data.errormsg : "发生未知错误");
            }
        }
    } else {
        alert("服务器连接出错");
    }
    return null;
}

let jsonErrorHandlers = [];

function setAjaxErrorHandlers(handler) {
    jsonErrorHandlers.push(handler);
}

function getAsUriParameters(url, data) {
    let p = "";
    for (let prop in data) {
        p += encodeURIComponent(prop) + '=' +
            encodeURIComponent(data[prop]) + '&';
    }

    p = p.substring(0, p.length - 1);
    return url + (url.indexOf("?") > 0 ? "" : "?") + p;
}

export default {
    getJson, postJson, postFile, putJson, delJson, setAjaxErrorHandlers
};
